import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/career/Hero';
import Explore from '../component/career/Explore';
import Positions from '../component/career/Positions';
import Benefits from '../component/career/Benefits';
import Footer from '../component/layout/Footer';

export default function Career() {
  return (
    <div>
      <Header />
      <Hero />
      <Explore />
      <Positions />
      <Benefits />
      <Footer />
    </div>
  )
}